/* eslint-disable react/require-default-props */
import React from 'react';
import { func, number, string } from 'prop-types'; // components

import Icons from '../icons/collection'; // styles

import { ArrowWrapper, Next, Prev } from './styled/styles';

var Arrows = function Arrows(_ref) {
  var calendarWeekLength = _ref.calendarWeekLength,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      hideArrows = _ref.hideArrows,
      toggleArrow = _ref.toggleArrow;
  return /*#__PURE__*/React.createElement(ArrowWrapper, null, hideArrows > 0 && /*#__PURE__*/React.createElement(Prev, {
    onClick: function onClick(e) {
      return toggleArrow(e, 'prev');
    },
    "data-test-id": "prev-click"
  }, /*#__PURE__*/React.createElement(Icons.NavigateLeft, {
    role: "button",
    height: "16",
    width: "11",
    "data-test-id": "navigate left icon",
    "data-analytics-id": "scl-arrow-prev",
    "data-analytics-label": dataAnalyticsLabel
  })), hideArrows < calendarWeekLength && /*#__PURE__*/React.createElement(Next, {
    onClick: function onClick(e) {
      return toggleArrow(e, 'next');
    },
    "data-test-id": "next-click"
  }, /*#__PURE__*/React.createElement(Icons.NavigateRight, {
    role: "button",
    height: "16",
    width: "11",
    "data-test-id": "navigate right icon",
    "data-analytics-id": "scl-arrow-next",
    "data-analytics-label": dataAnalyticsLabel
  })));
};

Arrows.propTypes = {
  /**
    length of calendar week
  */
  calendarWeekLength: number,

  /**
  Optional: Define data analytics label
  */
  dataAnalyticsLabel: string,

  /**
    hide arrows based on position
  */
  hideArrows: number,

  /**
    click handler to toggle weekly view
  */
  toggleArrow: func
};
export default Arrows;